import moment from 'moment';
import React from 'react';
import Modal from '../../Components/Modal/Modal';
import RadioButtonGroup from '../../Components/RadioButtonGroup/RadioButtonGroup';
import StatusBadge from '../../Components/StatusBadge/StatusBadge';
import { Button } from '../../Components/StyledComponents';
import Table from '../../Components/Table/Table';
import { convertCost } from '../../Utils/functions';
import './PointHistory.scss'
import 'moment/locale/ko'
import axios from 'axios';
import { alertRef } from '../../App';
import { Link } from 'react-router-dom';

const statusList = {
    CancelHistory : '취소사유',
    Normal : '정상처리',
    Cancel : '취소 완료'
}

const variant = {
    CancelHistory : 'primary',
    Normal : 'normal',
    Cancel : 'danger'
}

const PointHistory = () => {
    const modalRef = React.useRef(null);

    const [ data, setData ] = React.useState({});
    const [ reason, setReason ] = React.useState('');

    function getTime(date){
        let hour =  moment(date).utc().format('YYYY-MM-DD HH:mm:ss')
        let now = moment(new Date).format('YYYY-MM-DD HH:mm:ss')
  
        if(Math.abs(moment(now, 'YYYY-MM-DD HH:mm:ss').diff(moment(hour, 'YYYY-MM-DD HH:mm:ss'))) < 86400000 ) return true
        return false
    }

    const reqCancel = () => {
        axios.post('/api/point/cancel',{
            HistoryId : data._id.$oid,
            Reason : reason
        })
        .then((data) => {
            if(data.status === 204 ){
                modalRef.current.closeModal();
                alertRef.current.showAlert({ title : `취소 처리가 완료되었어요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
            }
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `다시 시도해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }

    const columnsPoint = React.useMemo(
        () => [
          {
            Header: '사용일시',
            accessor: 'Date.$date', // accessor is the "key" in the data
            disableFilters : true,
            width : 145,
            minWidth : 145,
            Cell : (props) => {
                return(
                    <p>{moment(props.cell.value).utc().locale('ko').format('YY-MM-DD(dd) HH:mm:ss')}</p>
                )
            }
          },
          {
            Header: '유저번호',
            accessor: 'UserInfo',
            disableSortBy : true,
            minWidth : 140,
            width : 140,
            Cell : (props) => {
                if(typeof props.cell.value !== 'undefined'){
                    return(
                        <Link to={`/user-info/${props.cell.value._id.$oid}`}>
                            <p style={{ color : '#f95f53'}}>{props.cell.value.Tel}</p>
                        </Link>    
                    )
                }else {
                    return(
                        <p style={{ color : '#f95f53'}}>탈퇴한 회원</p>
                    )
                }
            }
          },
          {
            Header: '결제금액',
            accessor: 'Price',
            disableFilters : true,
            minWidth : 110,
            width : 110,
            Cell : (props) => {
                return(
                    <p>{convertCost(props.cell.value)}원</p>
                )
            }
        },
        {
            Header: '적립/사용',
            accessor: 'Point',
            disableFilters : true,
            minWidth : 110,
            width : 110,
            Cell : (props) => {
                return(
                    <p style={{ fontWeight : 'bold', color : '#3f3f3f' }}>{convertCost(props.cell.value)} P</p>
                )
            }
        },
        {
            Header: '잔여포인트',
            accessor: 'RemainPoint',
            disableFilters : true,
            minWidth : 120,
            width : 120,
            Cell : (props) => {
                return(
                    <p style={{ fontWeight : 'bold', color : '#3f3f3f' }}>{convertCost(props.cell.value)} P</p>
                )
            }
        },
        {
            Header: '구분',
            accessor: 'Type',
            disableFilters : true,
            minWidth : 100,
            width : 100,
            Cell : (props) => {
                return(
                    <p>{props.cell.value === 'Delivery' ? '배달/포장' : props.cell.value === 'Commerce' ? '커머스 쿠폰' : '매장'}</p>
                )
            }
        },
        {
            Header: '상태',
            accessor: 'State',
            minWidth : 100,
            width : 100,
            maxWidth : 100,
            disableFilters : true,
            isDropdown : true,
            options : [
              { key : 'test1' , value : 'Ccc11'},
              { key : 'test2' , value : '22'},
              { key : 'test3' , value : '33'},
              { key : 'test4' , value : '44'},
            ],
            style : {
                overflow : 'visible',
                overflowY : 'visible'
            },
            Cell : (props) => {
                if( props.cell.value === 'Normal' && getTime(props.cell.row.cells[0].value) ){
                    return (
                        <Button variant='sub' onClick={() => openCancelModal(props.cell.row.original)} small style={{ paddingLeft : 16, paddingRight : 16 }}>
                            취소하기
                        </Button>
                    )
                }else {
                    return(
                        <StatusBadge Status={statusList[props.cell.value]} variant={variant[props.cell.value]} Reason={props.cell.row.original.Reason}/>
                    )
                }
            },
        },
        ],[]
    )

    const openCancelModal = (data) => {
        setData(data);
        modalRef.current.openModal();
    }

    return (
        <div className='point-history'>
            <Table columns={columnsPoint} url={'/api/history/point'}/>
            <Modal ref={modalRef} onBackdropClick={() => modalRef.current.closeModal()} contentContainer={{ maxWidth : 500 }}>
                <div>
                    {
                        Object.keys(data).length > 0 &&
                        <>
                            <div className='row' style={{ alignItems : 'flex-start', marginBottom : 40 }}>
                                <p className='modal-header'>포인트 취소 사유를<br/>선택해주세요.</p>
                                <img src={require('../../aseets/icons/close.svg').default} style={{ width : 24, height : 24 }} onClick={() => modalRef.current.closeModal()}/>
                            </div>

                            <div className='row'>
                                <p className='info-title'>결제일시</p>
                                <p className='info-text'>{moment(data.Date.$date).utc().locale('ko').format('YY-MM-DD(dd) HH:mm:ss')}</p>
                            </div>

                            <div className='row'>
                                <p className='info-title'>유저번호</p>
                                <p className='info-text'>{data.UserInfo.Tel}</p>
                            </div>

                            <div className='row'>
                                <p className='info-title'>결제금액</p>
                                <p className='info-text'>{convertCost(data.Price)}원</p>
                            </div>

                            <div className='row'>
                                <p className='info-title'>적립포인트</p>
                                <p className='info-text'>{convertCost(data.Point)}P</p>
                            </div>

                            <div className='line'/>

                            <p className='info-title' style={{ marginBottom : 16 }}>취소사유</p>
                            <RadioButtonGroup
                                value={reason}
                                small
                                id="reason"
                                onChange={(val) => setReason(val)}
                                options={[
                                    { value : '적립/사용 금액 오류', label : '적립/사용 금액 오류'},
                                    { value : '오적립/사용', label : '오적립/사용'},
                                    { value : '환불', label : '환불'},
                                    { value : '중복 적립/사용', label : '중복 적립/사용'},
                                    { value : '기타', label : '기타'}
                                ]}
                                perRows={3}
                                radioStyle={{ marginBottom : 16 }}
                            />

                            <div style={{ width : '100%', justifyContent : 'flex-end', display : 'flex'}}>
                                <Button
                                    variant={'main'}
                                    fontSize={16}
                                    onClick={() => alertRef.current.showAlert({ title : `정말 취소 할까요?`, subTitle : `${reason}(으)로 인한 적립 취소\n위 취소사유가 맞는지 다시 한번 확인해주세요.`, isConfirm : true, confirmText : '취소하기', isCancel : true, cancelText : '닫기', onConfirm : () => {alertRef.current.hideAlert();reqCancel()} })}
                                    style={{ paddingLeft : 30, paddingRight : 30, paddingTop : 16, paddingBottom : 16, marginTop : 24 }}>
                                    취소하기
                                </Button>
                            </div>
                        </>
                    }
                    
                </div>
            </Modal>
        </div>
    )
}

export default PointHistory;